import React from 'react';
import { AvTooltip, avTooltipProps, AvTooltipProps, StyledTooltipTitleWithIcon } from '@fabric-ui/components';
import { FormatterType } from '@fabric-ui/components/Table';
import { TooltipProps } from '@mui/material';
import { StyledBadge, StyledBadgeProps } from './StyledBadge';

export type WithDescriptionTooltipProps = {
  /**
   * @description If `true`, will badgify the children with an icon and attach the tooltip to it. otherwise attaches the tooltip to the children.
   * @default false
   */
  badgify?: boolean;
  badgeProps?: StyledBadgeProps;
} & TooltipProps;

function WithDescriptionTooltip({ badgify = false, children, badgeProps, ...props }: WithDescriptionTooltipProps) {
  if (badgeProps?.type !== FormatterType.array && badgeProps?.type !== FormatterType.date && !props.title) {
    return children;
  }

  if (badgify) {
    return (
      <StyledBadge tooltipProps={props} {...badgeProps}>
        {children}
      </StyledBadge>
    );
  }

  const { title, ...rest } = props;
  return (
    <AvTooltip
      {...avTooltipProps}
      muiProps={{ ...avTooltipProps.muiProps, ...rest } as AvTooltipProps['muiProps']}
      title={title ? <StyledTooltipTitleWithIcon>{title}</StyledTooltipTitleWithIcon> : title}>
      {children}
    </AvTooltip>
  );
}

export default WithDescriptionTooltip;
